<template>
    <nav>
        <div v-if="!isDashboard" class="m-dashboardTopMenu m-dashboardTopMenu--left">
            <div class="m-dashboardTopMenu__item">
                <router-link
                    :to="{ name: 'dashboard-summary' }"
                    class="a-link a-link--underline m-dashboardTopMenu__link m-dashboardTopMenu__link--flex"
                >
                    <a-icon
                        icon="GoBackArrow"
                        class="a-icon a-icon--marginRight-10"
                    />&nbsp; Powrót do panelu klienta
                </router-link>
            </div>
        </div>
        <div class="m-dashboardTopMenu">
            <div class="m-dashboardTopMenu__item">
                <p
                    class="a-text m-dashboardTopMenu__link m-dashboardTopMenu__timer"
                >
                    Twoja sesja wygaśnie za {{ timeLeft }}
                    <span
                        class="m-dashboardTopMenu__link m-dashboardTopMenu__link--underline"
                        @click="extendSession"
                        >przedłuż</span
                    >
                </p>
            </div>
            <router-link
                :to="{ name: 'dashboard-summary' }"
                class="a-link m-dashboardTopMenu__link m-dashboardTopMenu__item"
            >
                <a-icon icon="User" class="a-icon a-icon--marginRight-5" />
                Panel klienta
            </router-link>
            <div class="m-dashboardTopMenu__item">
                <router-link
                    :to="{ name: 'dashboard-logout' }"
                    class="a-link m-dashboardTopMenu__link"
                    @click="stopInterval(interval)"
                >
                    Wyloguj
                </router-link>
            </div>
        </div>
    </nav>
</template>

<script>
import moment from 'moment'
import VueJwtDecode from 'vue-jwt-decode'

export default {
    data() {
        return {
            timer: 900000
        }
    },
    computed: {
        isDashboard() {
            return !!this.$route.matched.find(
                route => route.path === '/dashboard'
            )
        },
        fetchUserStatus() {
            return this.$store.getters['users/status']
        },
        fetchToken() {
            return this.$store.getters['users/token']
        },
        decodedToken() {
            if (this.fetchToken) {
                return VueJwtDecode.decode(this.fetchToken)
            } else {
                return false
            }
        },
        timeLeft() {
            return moment(this.timer)
                .locale('pl')
                .format('mm:ss')
        }
    },
    methods: {
        sessionTimer() {
            let savedToken = this.decodedToken
            const end = moment.unix(this.decodedToken.exp)
            const iat = moment.unix(this.decodedToken.iat)
            // eslint-disable-next-line no-use-before-define
            this.stopInterval(interval)

            const sessionDuration = moment(end).diff(iat)
            const sessionEnd = moment().add(sessionDuration, 'milliseconds')
            const interval = setInterval(() => {
                // if the token expire date was changed restart timer
                if (this.decodedToken && (this.decodedToken.exp !== savedToken.exp)) {
                    savedToken = this.decodedToken.exp
                    this.stopInterval(interval)
                    this.$store
                        .dispatch('users/checkTokenValidity')
                        .then(() => {
                            this.sessionTimer()
                        })
                }
                const now = moment()
                let sum = moment(sessionEnd).diff(now)
                this.timer = moment(sum)
                // If duration is less then 1s remove interval and log out user
                if (sum <= 1000) {
                    sum = 0
                    this.stopInterval(interval)
                    if (this.fetchUserStatus !== 'loggedOut') {
                        this.stopInterval(interval)
                        this.$store.dispatch('users/logout').then(() => {
                            this.stopInterval(interval)
                            this.$router.push({ name: 'start' })
                        })
                    }
                }
            }, 1000)
        },
        extendSession() {
            return this.$store.dispatch('users/extendSession')
        },
        stopInterval(interval) {
            clearInterval(interval)
        }
    },
    mounted() {
        setTimeout(() => {
            this.$store.dispatch('users/checkTokenValidity').then(() => {
                this.sessionTimer()
            })
        }, 1000)
    }
}
</script>
